import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

import styles from './PhoneCell.module.scss'

type PhoneCellProps = Pick<TableCellProps, 'hasIncreasedHeight'> & {
  phone?: React.ReactNode
}

export const PhoneCell = ({ phone, hasIncreasedHeight }: PhoneCellProps) => (
  <Table.Cell type="body" {...{ hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      justify="center"
      tagName="span"
    >
      {phone}
    </Box>
  </Table.Cell>
)
